"use client";

import { MadsBox, MadsLoadingSpinner } from "@mads/ui-react/next";
import { useSignIn } from "@/features/signIn/hooks/useSignIn";
import Header from "@/components/layout/Header";
import SignInWrapper from "../components/SignInWrapper";

export default function SignIn() {
  const { pageContent, welcomeInProxyUrl,status } = useSignIn();
 if (status === "loading")
    return (
      <MadsBox h="100vh" w="100%" center>
        <MadsLoadingSpinner size="lg" />
      </MadsBox>
    );
  if (!pageContent) return null;

  return (
    <div className="mads-scheme-dark">
      <Header showSignOut={false} isPageDarkMode={true} />
      <MadsBox
        className="welcome-bg"
        style={
          {
            "--bg-url": `url(${welcomeInProxyUrl})`,
          } as React.CSSProperties
        }
      >
        <SignInWrapper />
      </MadsBox>
    </div>
  );
}
